import axios, { Canceler } from "axios"

/**
 * 自定义取消请求类
 */
class RequestCancel {
  pending = new Map<string, Canceler>()

  pop(hash: string) {
    if (this.pending.has(hash)) {
      // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
      const cancel = this.pending.get(hash)

      cancel && cancel(hash)
      this.pending.delete(hash)
    }
  }

  push(hash: string) {
    return new axios.CancelToken((cancel) => {
      if (!this.pending.has(hash)) {
        // 如果 pending 中不存在当前请求，则添加进去
        this.pending.set(hash, cancel)
      }
    })
  }
}

export default new RequestCancel()
